import { SET_MESSAGE, CLEAR_MESSAGE } from "../acions/types";

const initialState = {};

export default function message(state = initialState, action: any) {
  const { type, payload } = action;

  switch (type) {
    case SET_MESSAGE:
      return { message: payload };

    case CLEAR_MESSAGE:
      return { message: undefined };

    default:
      return state;
  }
}
